import React, { Fragment } from 'react'
import { MarkdownContent } from '@/components/organisms/MarkdownContent/MarkdownContent'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { ReactComponent as Loop } from '@/assets/images/loop.svg'
import { ReactComponent as BBLogo } from '@/assets/icons/footer-logo.svg'
import { ReactComponent as Arrow } from '@/assets/icons/thin-arrow-purple.svg'
import { HeroSingleCaseStudyProps } from '@/components/organisms/HeroSingleCaseStudy/types'

export function HeroSingleCaseStudy({ heading, author, job_title, logo, breadcrumbs }: HeroSingleCaseStudyProps) {
  return (
    <section className="p-24 netbook:px-90 netbook:py-64 flex flex-col items-center max-w-screen-desktop mx-auto">
      {breadcrumbs.length > 0 && (
        <div className="flex gap-12 items-center ">
          {breadcrumbs.map((item) => (
            <Fragment key={item._uid}>
              <CustomLink {...item} className="text-text-dark-300 netbook:hover:underline text-bodyM">
                {item.text}
              </CustomLink>
              <Arrow className="h-12 w-6 last:hidden" />
            </Fragment>
          ))}
        </div>
      )}
      {heading && (
        <div className="text-center [&_h1]:mb-16 [&_h1]:text-headingL-mobile [&_h1]:netbook:text-headingL [&_h1]:text-text-dark-900 [&>div]:px-0 [&>div]:pt-24 [&>div]:pb-16 [&>div]:netbook:px-24 [&_p]:text-bodyL [&_p]:text-text-dark-600 [&_p]:mb-0 [&_p]:font-sans max-w-5xl">
          <MarkdownContent content={heading[0].content} heading={heading[0].heading} />
        </div>
      )}
      <div className="flex flex-col netbook:flex-row items-center justify-center gap-4 netbook:gap-16 text-text-dark-600 text-bodyS">
        {author && <p>{author}</p>}
        <span className="bg-primary-500 size-8 rounded-full" />
        {job_title && <p>{job_title}</p>}
      </div>
      {logo && (
        <div className="relative flex w-fit mt-24">
          <Loop />
          <div className="grid place-content-center rounded-full border-1 border-grey-100 p-20 aspect-square absolute top-1/2 -translate-y-1/2 left-1/4 -translate-x-1/2">
            <img src={logo.image} alt={logo.alt_tag} className="size-40 select-none" />
          </div>
          <div className="grid place-content-center rounded-full border-1 border-grey-100 p-20 aspect-square absolute top-1/2 -translate-y-1/2 right-1/4 translate-x-1/2">
            <BBLogo className="size-40" />
          </div>
        </div>
      )}
    </section>
  )
}
